// Help's always-on pieces, on every board kind and on a phone (Features 4, onboarding parts 4 and 6): the first-time
// tips, the "did you know" hints, keeping where the user is, and, where the board has no corner of its own (a typed
// board, a phone), the corner's cards: While you were away, or What's new.

import { useEffect } from "react";
import { useStore } from "../state/store";
import { Away, useAway } from "./Away";
import { startHints } from "./hints";
import { useKeepPlace } from "./place";
import { Tips } from "./Tips";
import { useNews, WhatsNew } from "./WhatsNew";
import "./settings";
import "./commands";
import "./chrome.css";

/** While you were away, else What's new, else what the place shows otherwise: one card at a time. */
export function HelpNote({ fallback = null }: { fallback?: React.ReactNode }) {
  const away = useAway();
  const news = useNews();
  if (away) return <Away since={away} />;
  if (news) return <WhatsNew news={news} />;
  return <>{fallback}</>;
}

export function HelpLayer({ corner }: { corner: boolean }) {
  const ready = useStore((s) => s.phase === "ready" && !s.guest && !!s.workspace);
  useKeepPlace();
  useEffect(() => {
    if (ready) startHints();
  }, [ready]);
  return (
    <>
      <Tips />
      {/* a canvas shows the card in its corner (src/chrome/Corner.tsx) */}
      {!corner && ready && (
        <div className="help-notes">
          <HelpNote />
        </div>
      )}
    </>
  );
}
